import React, { useState } from "react";
import { Upload, message } from "antd";
import { TiTimes } from "react-icons/ti";
import { UPLOADED_IMAGE_SIZE } from "../../../utils/helper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { uploadFiles } from "../../../services/scanUpload";
import { CircularProgress } from "@mui/material";
import { FaSquarePlus } from "react-icons/fa6";
import { LiaCloudUploadAltSolid } from "react-icons/lia";

const UploadId = ({ componentType, id, setId = null, setData = null }) => {
  const [uploadedFile, setUploadedFiles] = useState({});
  const [loading, setLoading] = useState(false);

  const handleBeforeUpload = (file) => {
    if (file.size > UPLOADED_IMAGE_SIZE) {
      message.info("File size must be lesser than 10 MB");
      return false;
    }
    return true;
  };

  const uploadFile = async (options) => {
    const { file } = options;

    const frmData = new FormData();
    frmData.append("file", file);
    setLoading(true);

    try {
      let response = await uploadFiles(frmData);

      if (!Boolean(response)) {
        message.info("Something went wrong");
        setLoading(false);
        return;
      }

      const prevData = Boolean(id && Array.isArray(id)) ? [...id] : [];
      prevData.push(response);

      if (componentType === "addPrimaryGuestDrawer") {
        setData("idImages", prevData);
      } else if (componentType === "profileInfo") {
        setData && setData("logo", ...prevData);
      } else {
        setId && setId(prevData);
      }

      message.success("Success! Your image is now uploaded.");
    } catch (error) {
      message.error(error, "something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveUrl = (url) => {
    // remove file from uploadedFile state object and update state
    const updatedFilesObj = {};
    for (let i in uploadedFile) {
      if (url !== uploadedFile[i].name) {
        updatedFilesObj[i] = uploadedFile[i];
      }
    }

    setUploadedFiles(updatedFilesObj);

    let idCopy = [...id];
    let index = idCopy.indexOf(url);

    if (index === -1) {
      return;
    }

    idCopy?.splice(index, 1);

    if (componentType === "addPrimaryGuestDrawer") {
      setData && setData("idImages", idCopy);
    } else if (componentType === "profileInfo") {
      setData && setData("logo", null);
    } else {
      setId && setId(idCopy);
    }
  };

  return (
    <UploadUI
      componentType={componentType}
      loading={loading}
      handleBeforeUpload={handleBeforeUpload}
      handleRemoveUrl={handleRemoveUrl}
      uploadFile={uploadFile}
      id={id}
      setData={setData}
    />
  );
};

const UploadUI = ({
  loading,
  handleBeforeUpload,
  handleRemoveUrl,
  uploadFile,
  id,
  componentType,
  setData,
}) => {
  return componentType === "addPrimaryGuestDrawer" ? (
    <div className="border-[1px] border-dashed flex flex-col gap-[12px] justify-between items-center p-[12px]">
      {id?.length > 0 ? (
        <span className="text-sm py-1 text-[#555454]  flex h-[100%]">
          {id?.map((item, index) => {
            return (
              <div key={index} className="bg-slate-100 rounded relative mx-1">
                <TiTimes
                  onClick={() => handleRemoveUrl(item, index)}
                  className="float-right cursor-pointer absolute left-3 bottom-2 text-sm text-[red] bg-slate-400 rounded"
                />

                <LazyLoadImage
                  className="w-[100px] h-[100px]"
                  alt="hotel"
                  src={item} // use normal <img> attributes as props
                />
              </div>
            );
          })}
        </span>
      ) : (
        <LiaCloudUploadAltSolid className="text-[#222B45] text-[16px]" />
      )}
      <div className="text-[#222B45] text-[14px] font-[300]">
        Attach Id chose the Id you want to upload from your computer
      </div>
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <Upload
          multiple={true}
          customRequest={uploadFile}
          // onChange={handleChange}
          beforeUpload={handleBeforeUpload}
          showUploadList={false}
          accept=".png,.jpeg,.jpg"
        >
          <FaSquarePlus className="text-[#047857] text-[24px] cursor-pointer" />{" "}
        </Upload>
      )}{" "}
    </div>
  ) : (
    <div className="border-[1px] border-dashed flex flex-col gap-[12px] bg-[#F9FBFD] justify-center items-center h-[100%] w-[100%]">
      {Boolean(id) ? (
        <div className="w-[100%] h-[100%]  relative ">
          <img
            src={id}
            alt="rect"
            id="viewer"
            className="w-[100%] h-[100%] rounded-[8px]"
          />

          <div
            className="absolute top-0 right-0 cursor-pointer"
            onClick={() => {
              setData("logo", null);
            }}
          >
            <TiTimes className="z-[100] text-[30px]" />
          </div>
        </div>
      ) : (
        <>
          {loading ? (
            <CircularProgress size={16} />
          ) : (
            <Upload
              multiple={true}
              customRequest={uploadFile}
              beforeUpload={handleBeforeUpload}
              showUploadList={false}
              accept=".png,.jpeg,.jpg"
            >
              <div className="bg-[#F9FBFD] font-[500] text-[#007FFF]  cursor-pointer w-[100%] h-[100%] flex justify-center items-center">
                Upload
              </div>
            </Upload>
          )}
        </>
      )}
    </div>
  );
};

export default UploadId;
